import { combineReducers } from 'redux'
import { router } from './router'
import { IRouter } from '../types/router'
import { notifications } from './notifications'
import { INotifications } from '../types/notifications'
import { auth } from './auth'
import { IAuth } from '../types/auth'
import { groups } from './groups'
import { IGroups } from '../types/groups'
import { groupsDetailed } from './groupsDetailed'
import { IGroupsDetailed } from '../types/groupsDetailed'
import { group } from './group'
import { IGroupDetailed } from '../types/group'
import { editorsPerGroup } from './editorsPerGroup'
import { IEditorsPerGroup } from '../types/editorsPerGroup'
import { pack } from './pack'
import { PackType } from '../types/pack'
import { file } from './file'
import { IFile } from '../types/file'
import { datafile } from './datafile'
import { IDatafile } from '../types/datafile'
import { datachart } from './datachart'
import { IDataChartData } from '../types/datachart'
import { serverConfig } from './config'
import { IServerConfig } from '../types/config'
import { search } from './search'
import { ISearch } from '../types/search'
import { publishedSearch } from './publishedSearch'
import { IPublishedSearch } from '../types/publishedSearch'
import { mediaType } from './mediaType'
import { IMediaType } from '../types/mediaType'
import { mediaTypes } from './mediaTypes'
import { IMediaTypes } from '../types/mediaTypes'
import { mediaTypeGroup } from './mediaTypeGroup'
import { IMediaTypeGroup } from '../types/mediaTypeGroup'
import { mediaTypeGroups } from './mediaTypeGroups'
import { IMediaTypeGroups } from '../types/mediaTypeGroups'
import { capabilities } from './capabilities'
import { ICapabilities } from '../types/capabilties'
import { capability } from './capability'
import { ICapability } from '../types/capability'
import { IPublishingLocations } from '../types/publishingLocations'
import { publishingLocations } from './publishingLocations'
import { IModal } from '../types/modal'
import { modal } from './modal'
import { languages } from './languages'
import { ILanguages } from '../types/languages'
import { publishedGraphic } from './publishedGraphic'
import { IPublishedGraphic } from '../types/publishedGraphic'
import { capabilitiesSummary } from './capabilitiesSummary'
import { ICapabilitiesSummaryState } from '../types/capabilitiesSummary'
import { userPreferences } from './userPreferences'
import { IUserPreferences } from '../types/userPreferences'

interface IState {
  router: IRouter
  notifications: INotifications
  auth: IAuth
  groups: IGroups
  groupsDetailed: IGroupsDetailed
  group: IGroupDetailed
  editorsPerGroup: IEditorsPerGroup
  pack: PackType
  file: IFile
  datafile: IDatafile
  serverConfig: IServerConfig
  datachart: IDataChartData
  search: ISearch
  publishedSearch: IPublishedSearch
  mediaType: IMediaType
  mediaTypes: IMediaTypes
  mediaTypeGroup: IMediaTypeGroup
  mediaTypeGroups: IMediaTypeGroups
  capabilities: ICapabilities
  capability: ICapability
  publishingLocations: IPublishingLocations
  modal: IModal
  languages: ILanguages
  publishedGraphic: IPublishedGraphic
  capabilitiesSummary: ICapabilitiesSummaryState
  userPreferences: IUserPreferences
}

export const rootReducer = combineReducers<IState>({
  router,
  notifications,
  auth,
  groups,
  groupsDetailed,
  group,
  editorsPerGroup,
  pack,
  file,
  datafile,
  serverConfig,
  datachart,
  search,
  publishedSearch,
  mediaType,
  mediaTypes,
  mediaTypeGroup,
  mediaTypeGroups,
  capabilities,
  capability,
  publishingLocations,
  modal,
  languages,
  publishedGraphic,
  capabilitiesSummary,
  userPreferences,
})

export type AppStateType = ReturnType<typeof rootReducer>
